import { cn } from '@c2fo/liquidity';
import useLocaleFormat from '@/utils/useLocaleFormat';

interface BuyerLogoProps {
  // buyer logo url
  buyerLogoUrl: string | null;
  // buyer name
  buyerName: string;
  // additional classNames
  className?: string;
  // number of new divisions
  newDivisionCount?: number;
  // referrer
  referrer?: 'offer-activity';
  // size of the logo, defaults to md
  size?: 'md' | 'lg' | 'xl' | '2xl';
}

const BuyerLogo = ({
  buyerLogoUrl,
  buyerName,
  className,
  newDivisionCount = 0,
  referrer,
  size = 'md',
}: BuyerLogoProps) => {
  const { asNumber } = useLocaleFormat();

  return (
    <div
      aria-label={buyerName}
      className={cn(
        'relative flex shrink-0 items-center justify-center rounded-full border-[0.5px] border-stroke bg-gray-100 font-medium',
        { 'bg-white bg-[length:80%] bg-center bg-no-repeat': !!buyerLogoUrl },
        { 'h-6 w-6 text-sm': size === 'md' },
        { 'h-11 w-11 text-xl': size === 'lg' },
        { 'h-12 w-12 text-2xl': size === 'xl' },
        { 'h-16 w-16 text-3xl': size === '2xl' },
        className
      )}
      role="img"
      style={buyerLogoUrl ? { backgroundImage: `url(${buyerLogoUrl})` } : undefined}
    >
      {!buyerLogoUrl && buyerName[0]}
      {newDivisionCount > 0 && (
        <div
          className={cn(
            'absolute flex h-5 w-5 items-center justify-center rounded-full border border-white bg-lightBlue-500 text-xs font-semibold',
            { '-right-1 -top-1 md:hidden': referrer !== 'offer-activity' },
            { '-top-2 left-0': referrer === 'offer-activity' }
          )}
        >
          {asNumber({ value: newDivisionCount })}
        </div>
      )}
    </div>
  );
};

export default BuyerLogo;
